module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1528-40987a7bd5ef310a4ef3302f000cd93e.png";